import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { formatAmount } from "../../../../services/utils";
import t from "i18n";

const PaperChart = ({ activeTabTypeInscrit, typeInscritData, typeCAData }) => {

    const ca = typeCAData || {};
    const nbrInscrit = typeInscritData || {};

    const fiduciaryMembers = nbrInscrit.fiduciaryMembers ? nbrInscrit.fiduciaryMembers : 0;
    const individualMembers = nbrInscrit.individualMembers ? nbrInscrit.individualMembers : 0;
    const nbrInscritTotal = nbrInscrit.total ? nbrInscrit.total : 0;

    const caFiduciare = ca.fiduciaryCA ? ca.fiduciaryCA : 0;
    const caIndividual = ca.individualCA ? ca.individualCA : 0;
    const caTotal = ca.total ? ca.total : 0;

    const totalForChart = activeTabTypeInscrit === "chiffreAffaire" ? caTotal : nbrInscritTotal;
    const fiduciareForChart = activeTabTypeInscrit === "chiffreAffaire" ? caFiduciare : fiduciaryMembers;
    const individualForChart = activeTabTypeInscrit === "chiffreAffaire" ? caIndividual : individualMembers;

    const data = [
        { name: "Individuelle", value: totalForChart > 0 ? Math.round((individualForChart / totalForChart) * 100) : 0, color: "#4285F4" },
        { name: "Fiduciaire", value: totalForChart > 0 ? Math.round((fiduciareForChart / totalForChart) * 100) : 0, color: "#E97E59" },
        { name: "All", value: individualForChart + fiduciareForChart === 0 ? 100 : 0, color: "#D8DDE2" }
    ];

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <PieChart width={200} height={200}>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={70}
                    dataKey="value"
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                </Pie>
                <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fontSize={16} fontWeight="bold" fill="#2C3E50">
                    {activeTabTypeInscrit === "chiffreAffaire" ? formatAmount(totalForChart, true) : totalForChart}
                </text>
                <Tooltip />
            </PieChart>

            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 10, marginTop: 10 }}>
                {[
                    { name: "Individuelle", value: totalForChart > 0 ? Math.round((individualForChart / totalForChart) * 100) : 0, color: "#4285F4" },
                    { name: "Fiduciaire", value: totalForChart > 0 ? Math.round((fiduciareForChart / totalForChart) * 100) : 0, color: "#E97E59" }
                ].map((entry, index) => (
                    <div key={index} style={{ display: "flex", flexDirection: 'column', alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <span style={{ width: 10, height: 10, borderRadius: "50%", background: entry.color, marginRight: 5 }}></span>
                            <span style={{ fontSize: 12, color: "#2C3E50", fontWeight: 500 }}>{t(entry.name)}</span>
                        </div>
                        <span style={{ color: '#29394D', fontSize: 20, fontWeight: 500, marginLeft: 5 }}>{entry.value}%</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default PaperChart;


// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/PaperChart.js